<template>
  <div class="page">
    <van-sticky>
      <van-search v-model="keyword" placeholder="请输入交易号/订单号" show-action @search="onSearch">
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <div class="separate"></div>
    </van-sticky>

    <van-list v-model:loading="loading" :finished="finished" @load="loadPage">
      <van-cell v-for="item in list" :key="item.id" :title="item.type" :value="item.transactionNo" is-link center
        @click="showApprove(item.id)" />
      <van-empty v-if="list.length === 0" description="暂无记录" />
    </van-list>

  </div>
</template>

<script>
import { Search, List, Cell, Sticky, Row, Col, Empty, Toast, Tab } from "vant";
import additionalApi from "@/api/additional";

const stateLabels = {
  0: "已提交",
  1: "加款成功",
  2: "加款失败",
};

export default {
  name: "AdditionalTodo",

  components: {
    [Search.name]: Search,
    [List.name]: List,
    [Cell.name]: Cell,
    [Sticky.name]: Sticky,
    [Row.name]: Row,
    [Col.name]: Col,
    [Empty.name]: Empty,
    [Toast.name]: Toast,
    [Tab.name]: Tab
  },

  data() {
    return {
      keyword: "",
      state: 0,
      list: [],
      loading: false,
      finished: false,
      page: 0,
      size: 20
    };
  },

  mounted() {
  },

  methods: {
    toStateLabel: function (val) {
      return stateLabels[val];
    },
    onSearch: function () {
      this.reloadPage();
    },
    loadPage: function () {
      additionalApi
        .page(++this.page, this.size, {
          transactionNo: this.keyword,
          state: this.state
        })
        .then((res) => {
          if (res.success) {
            this.list = this.list.concat(res.data.records);
          }
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (this.list.length >= res.data.total) {
            this.finished = true;
          }
        });
    },
    reloadPage() {
      this.list = [];
      this.page = 0;
      this.size = 20;
      this.loading = false,
        this.finished = false,
        this.loadPage();
    },
    showApprove(val) {
      this.$router.push({ name: "AdditionalApprove", params: { id: val } });
    }
  },
};
</script>

<style scoped>
.page {
  /* padding: 0px 10px; */
}

.separate {
  height: 10px;
  background-color: rgb(236, 232, 232);
}
</style>
